export enum Path {
  // Public
  Home = '',
  InternalServerError = 'internal-server-error',
  NotFound = '404',

  // Auth for parent (Sign in will be same for both)
  Auth = '',
  SignIn = 'sign-in',
  SignUp = 'sign-up',
  ForgotPassword = 'forgot-password',
  ForgotPasswordEmailSent = 'forgot-password-email-sent',
  PasswordReset = 'password-reset',
  PasswordResetSucceeded = 'password-reset-succeeded',
  PasswordResetFailed = 'password-reset-failed',
  AccountActivationToken = 'accountActivation',

  // Therapist sign up
  Therapist = 'therapist',
  TherapistSignUp = 'therapist/sign-up',
  TherapistOnboarding = 'onboarding',
  TherapistDashboard = 'dashboard',
  TherapistReviewInfo = 'review-info/:id',
  TherapistEditProfile = 'edit-profile',
  TherapistPartnerInfo = 'partner/:partnerId',
  TherapistPartnerCreateReview = 'partner/:partnerId/create-review',
  TherapistPartnerReviewInfo = 'partner/:partnerId/review-info/:gabaPlanId',


  // App base url
  App = '',

  // Admin
  Admin = 'admin',
  AdminAddProduct= 'add-product',
  AdminViewProducts= 'view-products',
  AdminEditProduct= 'edit-product/:productId',
  AdminAddOrganisation= 'add-organisation',
  AdminViewOrganisations= 'view-organisations',
  AdminEditOrganisation= 'edit-organisation/:organisationId',
  AdminAddVideo= 'add-video',
  AdminViewVideos= 'view-videos',
  AdminCreateAccount= 'create-account',
  AdminAddInterviewSlots= 'add-interview-slots',
  AdminTherapistStatus= 'check-therapist-status',
  AdminAddGabaCredit= 'add-gabadoo-credit',
  AdminParentDetails= 'parent-details',
  AdminParentGabaSummary= 'parent-gaba-summary/:parentId',
  AdminParentGabaPlanDetails= 'parent-gaba-plan/:gabadooId',
  AdminTherapistsDetails= 'therapists-details',
  AdminAddPartner= 'add-partner',
  AdminViewPartners= 'view-partners',
  AdminEditPartner = 'edit-partner/:partnerId',
  AdminAddResource = 'add-resource',
  AdminViewResources = 'view-resources',


  // Features
  ParentHome = '', // done
  Gabadoo = 'gabadoo', // done
  CreateGabadoo = 'create-gabadoo', // done
  DraftGabadoo = 'draft-gabadoo/:gabadooId', // done
  AddChild = 'create-child', // done
  EditChild = 'child-profile/:childId', // done
  Plan = 'gaba-plan/:gabadooId', // done
  Strategies = 'gaba-plan/strategies/:gabadooId', // done
  Products = 'gaba-plan/products/:gabadooId', // done
  Resources = 'gaba-plan/resources/:gabadooId', // done
  TherapistProfile = 'therapist/profile',
  Payment = 'payment-plan', // done
  SuccessPayment = 'payment-success', // done
  ParentAccount = 'account', // done
  ContinueGabadoo = 'continue-gabadoo/:oldGabadooId', // done
  UniqueGabadoo = 'gaba-link/:therapistUserId/:uniqueToken', // done
  ReviewGabadoo = 'review-gabadoo/:gabadooId', // done

  // Partner
  Partner = '',
  PartnerHome = 'partner',
  PartnerGabadoo = 'partner/gabadoo',
  PartnerGabadooPlanInfo = 'partner/gabadoo/plan/:gabadooId',
  PartnerAccount = 'partner/account',
}
